/** @file defaultStyleNotes: the style paragraph of an art brief before the user types their own. */

/** What a new puppet's style notes say. */
export const DEFAULT_STYLE_NOTES = 'pixel art, flat colours, no outline, transparent background';
